import {CancelTokenSource} from 'axios';
import {Employer} from './../models/Employer';
import {Async, AsyncPage, Empty} from 'Core/models/Async';
import {DateRange, EmptyDateRange} from 'Core/models/DateRange';
import {FilterOptionUnion, FilterOptionValue} from 'Core/models/FilterOption';
import {InequalityRangeFilter} from 'Core/models/InequalityRange';
import {Page} from 'Core/models/Page';
import {AgreementAcknowledgment} from 'Enrollment/models/AgreementAcknowledgment';
import {DaysToCompleteTurnAroundChartDetailsPayload} from 'Enrollment/models/DaysToCompleteTurnAroundChartDetailsPayload';
import {EnrollmentApplication} from 'Enrollment/models/EnrollmentApplication';
import {EmployerProfileDetails} from 'Enrollment/models/EmployerProfileDetails';
import {EnrollmentFile} from 'Enrollment/models/EnrollmentFile';
import {EnrollmentFileApplicationDetail} from 'Enrollment/models/EnrollmentFileApplicationDetails';
import {EnrollmentFileAuditDetail} from 'Enrollment/models/EnrollmentFileAuditDetail';
import {EnrollmentFileDetails} from 'Enrollment/models/EnrollmentFileDetails';
import {
  AccountProfileMetricsPayload,
  FileProfileMetricsPayload,
  FileTrackingMonitorMetricsPayload,
  FileFeedbackMetricsPayload,
  FilesNotProcessedMetricsPayload,
  OverallEnrollmentMetricsPayload,
} from 'Enrollment/models/EnrollmentMetricsPayload';
import {LifeCycleReportChartDetailsPayload} from 'Enrollment/models/LifeCycleReportChartDetailsPayload';
import {ProcessingAccuracyChartDetailsPayload} from 'Enrollment/models/ProcessingAccuracyChartDetailsPayload';
import {TotalRecordsChartDetailsPayload} from 'Enrollment/models/TotalRecordsChartDetailsPayload';
import {constant} from 'fp-ts/lib/function';
import * as O from 'fp-ts/lib/Option';
import {pipe} from 'fp-ts/lib/pipeable';
import {createAction} from 'Shared/utilities/actionCreator';
import {PageFetchAction} from 'Shared/utilities/sagaApiGenerators';
import {EnrollmentApplicationStatus} from '../../Shared/constants/EnrollmentApplicationStatus';
import {AWDHistoryDetail} from '../models/AWDStatusDetails';
import {EnrollmentApplicationTemplate} from '../models/EnrollmentApplicationTemplate';
import {ApplicationProcessingDetail} from '../models/ESRBPStatusDetails';
import {EnrollmentFileRecordValidationResult} from './../models/EnrollmentFileRecordValidationResult';
import {ExternalUploadEnrollmentApplication} from 'Enrollment/models/ExternalUploadEnrollmentApplication';
import {FileUploadInProgress} from 'Enrollment/models/FileUploadInProgress';
import {BrokerSpreadsheetUploadsMetrics} from 'Enrollment/models/BrokerSpreadsheetsUploadsMetrics';
import {EnrollmentFileErrorDetails} from 'Enrollment/models/EnrollmentFileErrorDetails';
import {Application} from 'Enrollment/models/Application';
import {FileUploadCancelTokenDetail} from 'Enrollment/models/FileUploadCancelTokenDetail';
import {Sort} from 'Shared/components/PagedView/Table/Sort';
import {AutoCompleteList} from 'Enrollment/models/AutoCompleteDto';
import { empty } from 'fp-ts/lib/Array';
import { TypeObject } from '@material-ui/core/styles/createPalette';
import { ExternalUploadEnrollmentApplicationDetails } from 'Enrollment/models/ExternalUploadEnrollmentApplicationDetails';

export enum EnrollmentFileActionType {
  CLEAR_ENROLLMENT_APPLICATION_TEMPLATES = 'enrollmentFile/CLEAR_ENROLLMENT_APPLICATION_TEMPLATES',
  GET_ENROLLMENT_FILE = 'enrollmentFile/GET_ENROLLMENT_FILE',
  GET_ENROLLMENT_FILES = 'enrollmentFile/GET_ENROLLMENT_FILES',
  CHANGE_ENROLLMENT_FILES = 'enrollmentFile/CHANGE_ENROLLMENT_FILES',
  CHANGE_ENROLLMENT_FILE = 'enrollmentFile/CHANGE_ENROLLMENT_FILE',
  CHANGE_ENROLLMENT_FILE_FILTERS = 'enrollmentFile/CHANGE_ENROLLMENT_FILE_FILTERS',
  CLEAR_ENROLLMENT_FILES = 'enrollmentFile/CLEAR_ENROLLMENT_FILES',
  GET_ENROLLMENT_FILE_By_CASE_REQUEST_ID = 'enrollmentFile/GET_ENROLLMENT_FILE_By_CASE_REQUEST_ID',
  CHANGE_FILESNOTPROCESSED_METRICS = 'enrollmentFileProcessing/CHANGE_FILESNOTPROCESSED_METRICS',
  CHANGE_FILE_PROFILE_METRICS = 'enrollmentFileProcessing/CHANGE_FILE_PROFILE_METRICS',
  CHANGE_ACCOUNT_PROFILE_METRICS = 'enrollmentFileProcessing/CHANGE_ACCOUNT_PROFILE_METRICS',
  CHANGE_FILE_TRACKING_MONITOR_METRICS = 'enrollmentFileProcessing/CHANGE_FILE_TRACKING_MONITOR_METRICS',
  CHANGE_FILEFEEDBACK_METRICS = 'enrollmentFileProcessing/CHANGE_FILEFEEDBACK_METRICS',
  CHANGE_ENROLLMENT_METRICS = 'enrollmentFileProcessing/CHANGE_ENROLLMENT_METRICS',
  GET_ENROLLMENT_METRICS = 'enrollmentFileProcessing/GET_ENROLLMENT_METRICS',
  GET_FILEFEEDBACK_METRICS = 'enrollmentFileProcessing/GET_FILEFEEDBACK_METRICS',
  GET_FILESNOTPROCESSED_METRICS = 'enrollmentFileProcessing/GET_FILESNOTPROCESSED_METRICS',
  GET_FILE_PROFILE_METRICS = 'enrollmentFileProcessing/GET_FILE_PROFILE_METRICS',
  GET_ACCOUNT_PROFILE_METRICS = 'enrollmentFileProcessing/GET_ACCOUNT_PROFILE_METRICS',
  GET_FILE_TRACKING_MONITOR_METRICS = 'enrollmentFileProcessing/GET_FILE_TRACKING_MONITOR_METRICS',
  CHANGE_ENROLLMENT_TAB = 'enrollmentFileProcessing/CHANGE_ENROLLMENT_TAB',
  GET_ENROLLMENT_FILES_APPLICATION_DETAILS = 'enrollmentFile/GET_ENROLLMENT_FILES_APPLICATION_DETAILS',
  CHANGE_ENROLLMENT_FILES_APPLICATION_DETAILS = 'enrollmentFile/CHANGE_ENROLLMENT_FILES_APPLICATION_DETAILS',
  GET_ENROLLMENT_FILES_APPLICATION_PROCESSING_DETAILS = 'enrollmentFile/GET_ENROLLMENT_FILES_APPLICATION_PROCESSING_DETAILS',
  CHANGE_ENROLLMENT_FILES_APPLICATION_PROCESSING_DETAILS = 'enrollmentFile/CHANGE_ENROLLMENT_FILES_APPLICATION_PROCESSING_DETAILS',
  UPLOAD_ENROLLMENT_FILE_APPLICATIONS = 'enrollmentFile/UPLOAD_ENROLLMENT_FILE_APPLICATIONS',
  GET_ENROLLMENT_APPLICATIONS = 'enrollmentFile/GET_ENROLLMENT_APPLICATIONS',
  CHANGE_ENROLLMENT_APPLICATIONS = 'enrollmentFile/CHANGE_ENROLLMENT_APPLICATIONS',
  CHANGE_IS_FILE_UPLOADING = 'enrollmentFile/CHANGE_IS_FILE_UPLOADING',
  CHANGE_ENROLLMENT_APPLICATION_FILTERS = 'enrollmentFile/CHANGE_ENROLLMENT_APPLICATION_FILTERS',
  CHANGE_ENROLLMENT_APPLICATION_ERROR_DETAIL_FILTERS = 'enrollmentFile/CHANGE_ENROLLMENT_APPLICATION_ERROR_DETAIL_FILTERS',
  CHANGE_EXTERNAL_UPLOAD_QUEUE_FILTERS = 'enrollmentFile/CHANGE_EXTERNAL_UPLOAD_QUEUE_FILTERS',
  GET_ENROLLMENT_APPLICATION_TEMPLATE = 'enrollmentFile/GET_ENROLLMENT_APPLICATION_TEMPLATE',
  CHANGE_ENROLLMENT_APPLICATION_TEMPLATE = 'enrollmentFile/CHANGE_ENROLLMENT_APPLICATION_TEMPLATE',
  GET_ENROLLMENT_FILES_AWD_HISTORY_DETAILS = 'enrollmentFile/GET_ENROLLMENT_FILES_AWD_HISTORY_DETAILS',
  CHANGE_ENROLLMENT_FILES_AWD_HISTORY_DETAILS = 'enrollmentFile/CHANGE_ENROLLMENT_FILES_AWD_HISTORY_DETAILS',
  UPDATE_ENROLLMENT_FILE_AUDIT_STATUS = 'enrollmentFile/UPDATE_ENROLLMENT_FILE_AUDIT_STATUS',
  CHANGE_FILE_UPLOAD_AGREEMENT_ACKNOWLEDGMENT = 'enrollmentFile/CHANGE_FILE_UPLOAD_AGREEMENT_ACKNOWLEDGMENT',
  SAVE_FILE_UPLOAD_AGREEMENT_ACKNOWLEDGMENT = 'enrollmentFile/SAVE_FILE_UPLOAD_AGREEMENT_ACKNOWLEDGMENT',
  CLEAR_FILE_UPLOAD_AGREEMENT_ACKNOWLEDGMENT = 'enrollmentFile/CLEAR_FILE_UPLOAD_AGREEMENT_ACKNOWLEDGMENT',
  CHANGE_AGREEMENT_ACCEPTED = 'enrollmentFile/CHANGE_AGREEMENT_ACCEPTED',
  GET_ENROLLMENT_FILE_AUDIT_DETAIL = 'enrollmentFile/GET_ENROLLMENT_FILE_AUDIT_DETAIL',
  CHANGE_ENROLLMENT_FILE_AUDIT_DETAIL = 'enrollmentFile/CHANGE_ENROLLMENT_FILE_AUDIT_DETAIL',
  GET_ENROLLMENT_FILE_RECORD_VALIDATION_RESULT = 'enrollmentFile/GET_ENROLLMENT_FILE_RECORD_VALIDATION_RESULT ',
  CHANGE_ENROLLMENT_FILE_RECORD_VALIDATION_RESULT = 'enrollmentFile/CHANGE_ENROLLMENT_FILE_RECORD_VALIDATION_RESULT ',
  GET_LIFE_CYCLE_REPORT_CHART_DETAILS = 'enrollmentFile/GET_LIFE_CYCLE_REPORT_CHART_DETAILS',
  CHANGE_LIFE_CYCLE_REPORT_CHART_DETAILS = 'enrollmentFile/CHANGE_LIFE_CYCLE_REPORT_CHART_DETAILS',
  GET_PROCESSING_ACCURACY_CHART_DETAILS = 'enrollment/GET_PROCESSING_ACCURACY_CHART_DETAILS',
  CHANGE_PROCESSING_ACCURACY_CHART_DETAILS = 'enrollment/CHANGE_PROCESSING_ACCURACY_CHART_DETAILS',
  CHANGE_EXTERNAL_ENROLLMENT_FILES = 'enrollment/CHANGE_EXTERNAL_ENROLLMENT_FILES',
  GET_DAYS_TO_COMPLETE_TURN_AROUND_CHART_DETAILS = 'enrollmentFile/GET_DAYS_TO_COMPLETE_TURN_AROUND_CHART_DETAILS',
  CHANGE_DAYS_TO_COMPLETE_TURN_AROUND_CHART_DETAILS = 'enrollmentFile/CHANGE_DAYS_TO_COMPLETE_TURN_AROUND_CHART_DETAILS',
  CHANGE_ENROLLMENT_APPLICATION_DETAILS_FILTERS = 'enrollment/CHANGE_ENROLLMENT_APPLICATION_DETAILS_FILTERS',
  GET_TOTAL_RECORDS_CHART_DETAILS = 'enrollmentFile/GET_TOTAL_RECORDS_CHART_DETAILS',
  CHANGE_TOTAL_RECORDS_CHART_DETAILS = 'enrollmentFile/CHANGE_TOTAL_RECORDS_CHART_DETAILS',
  GET_ENROLLMENT_APPLICATIONS_DETAIL = 'enrollmentFile/GET_ENROLLMENT_APPLICATIONS_DETAIL',
  CHANGE_ENROLLMENT_APPLICATIONS_DETAIL = 'enrollmentFile/CHANGE_ENROLLMENT_APPLICATIONS_DETAIL',
  GET_ENROLLMENT_File_APPLICATION_DETAIL = 'enrollment/GET_ENROLLMENT_APPLICATION_DETAIL',
  CHANGE_ENROLLMENT_File_APPLICATION_DETAIL = 'enrollment/CHANGE_ENROLLMENT_APPLICATION_DETAIL',
  GET_EXTERNAL_UPLOAD_QUEUE = 'enrollmentFile/GET_EXTERNAL_UPLOAD_QUEUE',
  CHANGE_EXTERNAL_UPLOAD_QUEUE = 'enrollmentFile/CHANGE_EXTERNAL_UPLOAD_QUEUE',
  CLEAR_EXTERNAL_UPLOAD_QUEUE_FILTERS = 'enrollmentFile/ CLEAR_EXTERNAL_UPLOAD_QUEUE_FILTERS',
  GET_FILE_VOLUME_CHART_DETAILS = 'enrollment/GET_FILE_VOLUME_CHART_DETAILS',
  CHANGE_FILE_VOLUME_CHART_DETAILS = 'enrollment/CHANGE_FILE_VOLUME_CHART_DETAILS',
  CLEAR_FILE_VOLUME_CHART_DETAILS = 'enrollment/CLEAR_FILE_VOLUME_CHART_DETAILS',
  GET_ESR_TOTAL_RECORDS = 'enrollment/GET_ESR_TOTAL_RECORDS',
  CHANGE_ESR_TOTAL_RECORDS = 'enrollment/CHANGE_ESR_TOTAL_RECORDS',
  CLEAR_ESR_TOTAL_RECORDS = 'enrollment/CLEAR_ESR_TOTAL_RECORDS',
  GET_EMPLOYERS = 'enrollment/GET_EMPLOYERS',
  CHANGE_EMPLOYERS = 'enrollment/CHANGE_EMPLOYERS',
  CLEAR_PROCESSING_ACCURACY_CHART_DETAILS = 'enrollment/CLEAR_PROCESSING_ACCURACY_CHART_DETAILS',
  GET_FILE_UPLOADS_IN_PROGRESS = 'enrollmentFile/GET_FILE_UPLOADS_IN_PROGRESS',
  CHANGE_FILE_UPLOADS_IN_PROGRESS = 'enrollmentFile/CHANGE_FILE_UPLOADS_IN_PROGRESS',
  GET_BROKER_SPREADSHEET_UPLOADS_METRICS = 'enrollmentFile/GET_BROKER_SPREADSHEET_UPLOADS_METRICS',
  CHANGE_BROKER_SPREADSHEET_UPLOADS_METRICS = 'enrollmentFile/CHANGE_BROKER_SPREADSHEET_UPLOADS_METRICS',
  GET_ENROLLMENT_ERROR_DETAILS = 'enrollmentFile/GET_ENROLLMENT_ERROR_DETAILS',
  CHANGE_ENROLLMENT_ERROR_DETAILS = 'enrollmentFile/CHANGE_ENROLLMENT_ERROR_DETAILS',
  GET_APPLICATIONS = 'enrollmentFile/GET_APPLICATIONS',
  CHANGE_APPLICATIONS = 'enrollmentFile/CHANGE_APPLICATIONS',
  CHANGE_APPLICATIONS_FILTERS = 'enrollmentFile/CHANGE_APPLICATIONS_FILTERS',
  CLEAR_APPLICATIONS = 'enrollmentFile/CLEAR_APPLICATIONS',
  CLEAR_APPLICATIONS_FILTERS = 'enrollmentFile/CLEAR_APPLICATIONS_FILTERS',
  UPLOAD_ENROLLMENT_EMPLOYER_PROFILES = 'enrollmentFile/UPLOAD_ENROLLMENT_EMPLOYER_PROFILES',
  CHANGE_BROKER_SPREADSHEET_CANCEL = 'enrollmentFile/CHANGE_BROKER_SPREADSHEET_CANCEL',
  CHANGE_GENELCO_ENROLLMENT_FILES = 'enrollment/CHANGE_GENELCO_ENROLLMENT_FILES',
  GET_EMPLOYER_PROFILE_DETAILS = 'enrollment/GET_EMPLOYER_PROFILE_DETAILS',
  CHANGE_EMPLOYER_PROFILE_DETAILS = 'enrollmentFile/CHANGE_EMPLOYER_PROFILE_DETAILS',
  CHANGE_FILE_UPLOAD_CANCEL_TOKENS = 'enrollmentFile/CHANGE_FILE_UPLOAD_CANCEL_TOKENS',
  CLEAR_ENROLLMENT_APPLICATIONS = 'enrolmentFile/CLEAR_ENROLLMENT_APPLICATIONS',
  CHANGE_ENROLLMENT_CLIENTONBOARDING_FILTERS = 'enrollmentFile/CHANGE_ENROLLMENT_CLIENTONBOARDING_FILTERS',
  CLEAR_CLIENT_ONBOARDING = 'enrolmentFile/CLEAR_CLIENT_ONBOARDING',
  CLEAR_CLIENT_ONBOARDING_SORT = 'enrolmentFile/CLEAR_CLIENT_ONBOARDING_SORT',
  CHANGE_CLIENT_ONBOARDING_SORT = 'enrolmentFile/CHANGE_CLIENT_ONBOARDING_SORT',
  CLEAR_GENELCO_APPLICATION_SORT = 'enrolmentFile/CLEAR_GENELCO_APPLICATION_SORT',
  CHANGE_GENELCO_APPLICATION_SORT = 'enrolmentFile/CHANGE_GENELCO_APPLICATION_SORT',
  PROCESS_BROKER_SPREADSHEET = 'enrollmentFile/PROCESS_BROKER_SPREADSHEET',
  GET_ACCOUNTNUMBERS = 'enrollment/GET_ACCOUNTNUMBERS',
  CHANGE_ACCOUNTNUMBERS = 'enrollment/CHANGE_ACCOUNTNUMBERS',
  GET_PRODUCTS = 'enrollment/GET_PRODUCTS',
  CHANGE_PRODUCTS = 'enrollment/CHANGE_PRODUCTS',
  CHANGE_FILTER_PROCESSACCURACY_CHART = 'enrollment/CHANGE_FILTER_PROCESSACCURACY_CHART',
  GET_EXTERNAL_UPLOAD_DETAILS_QUEUE = 'enrollmentFile/GET_EXTERNAL_UPLOAD_DETAILS_QUEUE',
  CHANGE_EXTERNAL_UPLOAD_DETAILS_QUEUE = 'enrollmentFile/CHANGE_EXTERNAL_UPLOAD_DETAILS_QUEUE',
  CHANGE_EXTERNAL_UPLOAD_QUEUE_DETAILS_FILTERS = 'enrollmentFile/CHANGE_EXTERNAL_UPLOAD_QUEUE_DETAILS_FILTERS',
  CLEAR_EXTERNAL_UPLOAD_QUEUE_DETAILS_FILTERS = 'enrollmentFile/ CLEAR_EXTERNAL_UPLOAD_QUEUE_DETAILS_FILTERS',
}

export enum EnrollmentFileType {
  EMW = 1,
  ESR = 2,
}

export type EnrollmentFileFilters = ESREnrollmentFileFilters | EMWEnrollmentFileFilters;

export const ESREmptyEnrollmentFileFilter: ESREnrollmentFileFilters = {
  TotalPendingApplications: O.none,
  totalSuccessfulApplications: O.none,
  accountNumber: '',
  agencyName: '',
  fileName: '',
  createdDate: EmptyDateRange,
  totalApps: O.none,
  itStatus: FilterOptionValue.EmptyOption(),
  businessStatus: FilterOptionValue.EmptyOption(),
  fileType: EnrollmentFileType.EMW,
  discrepancyCount: O.none,
  isEnrollmentFileDetails: false,
};

export type ESREnrollmentFileFilters = {
  TotalPendingApplications: InequalityRangeFilter;
  totalSuccessfulApplications: InequalityRangeFilter;
  accountNumber: string;
  agencyName: string;
  fileName: string;
  createdDate: DateRange;
  totalApps: InequalityRangeFilter;
  businessStatus: FilterOptionUnion;
  itStatus: FilterOptionUnion;
  fileType: EnrollmentFileType;
  discrepancyCount: InequalityRangeFilter;
  isEnrollmentFileDetails: boolean;
};

export const EMWEmptyEnrollmentFileFilter: EMWEnrollmentFileFilters = {
  agencyName: '',
  business_MaxDaysTook: '',
  caseNumber: '',
  itStatus: FilterOptionValue.EmptyOption(),
  businessStatus: FilterOptionValue.EmptyOption(),
  enrollmentPeriodName: '',
  iT_MaxDaysTook: '',
  fileType: EnrollmentFileType.EMW,
};

export type EMWEnrollmentFileFilters = {
  fileType: EnrollmentFileType;
  pageSize?: number;
  agencyName: string;
  caseNumber: string;
  itStatus: FilterOptionUnion;
  businessStatus: FilterOptionUnion;
  enrollmentPeriodName: string;
  business_MaxDaysTook: string;
  iT_MaxDaysTook: string;
};

export type EnrollmentApplicationDetailFilters = {
  id: string;
  finalDispositionStatus: FilterOptionUnion;
  statusId?: EnrollmentApplicationStatus;
  accountNumber: string;
  maskedIdentifier: string;
  requestType: FilterOptionUnion;
  product: string;
  firstName: string;
  lastName: string;
};
export const enrollmentApplicationDetailFiltersEmpty: EnrollmentApplicationDetailFilters = {
  id: '',
  finalDispositionStatus: FilterOptionValue.EmptyOption(),
  accountNumber: '',
  maskedIdentifier: '',
  requestType: FilterOptionValue.EmptyOption(),
  product: '',
  firstName: '',
  lastName: '',
};

export type FilterEnum = {
  name: string;
  value: string;
};

export enum EnrollmentApplicationTemplateType {
  GenelcoSpreadsheet = 1,
  BrokerSpreadsheet = 2,
}
export type EnrollmentApplicationsFilters = {
  fileName: string;
  templateId?: EnrollmentApplicationTemplateType;
  uploadedByUserName: string;
  fileUploadedDate: DateRange;
  fileStatuses: FilterOptionUnion[];
  numberOfRecords: InequalityRangeFilter;
  fileType: string;
  fileSize: string;
  rowCount: InequalityRangeFilter;
  templateType: string;
  fileStatusChangedDate: DateRange;
};
export const enrollmentApplicationsFiltersEmpty: EnrollmentApplicationsFilters = {
  fileName: '',
  uploadedByUserName: '',
  fileUploadedDate: EmptyDateRange,
  fileStatuses: [],
  numberOfRecords: O.none,
  fileType: '',
  fileSize: '',
  rowCount: O.none,
  templateType: '',
  fileStatusChangedDate: EmptyDateRange,
};

export type EmployerProfileUploadFilters = {
  fileName: string;
  fileType: string;
  successfulRecords: InequalityRangeFilter;
  fileUploadedDate: DateRange;
  unsuccessfulRecords: InequalityRangeFilter;
};
export const employerProfileUploadFiltersEmpty: EmployerProfileUploadFilters = {
  fileName: '',
  fileType: '',
  successfulRecords: O.none,
  fileUploadedDate: EmptyDateRange,
  unsuccessfulRecords: O.none,
};

export type EnrollmentApplicationErrorDetailFilters = {
  id: string;
  firstName: string;
  lastName: string;
  ssn: string;
  requestType: string;
  product: string;
  errorCount: InequalityRangeFilter;
  errorType: string;
  exportToCsv: boolean;
};

export const enrollmentApplicationErrorDetailFiltersEmpty: EnrollmentApplicationErrorDetailFilters = {
  id: '',
  firstName: '',
  lastName: '',
  ssn: '',
  requestType: '',
  product: '',
  errorCount: O.none,
  errorType: '',
  exportToCsv: false,
};

export type ExternalUploadQueueFilters = {
  fileName: string;
  accountNumber: string;
  templateId: EnrollmentApplicationTemplateType;
  uploadedByUserName: string;
  fileUploadedDate: DateRange;
  recentActionDate: DateRange;
  fileStatuses: FilterOptionUnion[];
  numberOfRecords: InequalityRangeFilter;
  fileType: string;
  fileSize: string;
  rowCount: InequalityRangeFilter;
  templateType: string;
  fileStatusChangedDate: DateRange;
  actionBy: string;
};
export const externalUploadQueueFiltersEmpty: ExternalUploadQueueFilters = {
  fileName: '',
  accountNumber: '',
  templateId: EnrollmentApplicationTemplateType.BrokerSpreadsheet,
  uploadedByUserName: '',
  fileUploadedDate: EmptyDateRange,
  recentActionDate: EmptyDateRange,
  fileStatuses: [
    {name: 'Received', value: 'Received', tag: 'SelectedOption'},
    {name: 'Processing', value: 'Processing', tag: 'SelectedOption'},
  ],
  numberOfRecords: O.none,
  fileType: '',
  fileSize: '',
  rowCount: O.none,
  templateType: '',
  fileStatusChangedDate: EmptyDateRange,
  actionBy: '',
};

export type ExternalUploadQueueDetailsFilters = {
  fileName: string;
  actionBy: string;
  actionDateTime: DateRange;
  actionName: string;
};
export const externalUploadQueueDetailsFiltersEmpty: ExternalUploadQueueDetailsFilters = {
  fileName: '',
  actionBy: '',
  actionDateTime: EmptyDateRange,
  actionName:'',
};

export type ApplicationsFilter = {
  id: string;
  firstName: string;
  lastName: string;
  ssn: string;
  errorCount: InequalityRangeFilter;
  requestTypes: FilterOptionUnion[];
  steps: FilterOptionUnion[];
  statuses: FilterOptionUnion[];
  exportToCsv: boolean;
};
export const applicationsFiltersEmpty: ApplicationsFilter = {
  id: '',
  firstName: '',
  lastName: '',
  errorCount: O.none,
  ssn: '',
  requestTypes: [],
  steps: [],
  statuses: [],
  exportToCsv: false,
};
export const processBrokerSpreadsheet = (fileId: string, processReasonId?: number, actionBy?: string) =>
  createAction(EnrollmentFileActionType.PROCESS_BROKER_SPREADSHEET, {fileId, processReasonId, actionBy});
export const getEnrollmentMetrics = () => createAction(EnrollmentFileActionType.GET_ENROLLMENT_METRICS);
export const changeEnrollmentMetrics = (enrollmentMetrics: Async<OverallEnrollmentMetricsPayload>) =>
  createAction(EnrollmentFileActionType.CHANGE_ENROLLMENT_METRICS, enrollmentMetrics);
export const getFileFeedbackMetrics = () => createAction(EnrollmentFileActionType.GET_FILEFEEDBACK_METRICS);
export const changeFileFeedbackMetrics = (fileFeedbackMetrics: Async<FileFeedbackMetricsPayload>) =>
  createAction(EnrollmentFileActionType.CHANGE_FILEFEEDBACK_METRICS, fileFeedbackMetrics);
export const getFilesNotProcessedMetrics = () => createAction(EnrollmentFileActionType.GET_FILESNOTPROCESSED_METRICS);
export const changeFilesNotProcessedMetrics = (filesNotProcessedMetrics: Async<FilesNotProcessedMetricsPayload>) =>
  createAction(EnrollmentFileActionType.CHANGE_FILESNOTPROCESSED_METRICS, filesNotProcessedMetrics);

export const getFileProfileMetrics = () =>
  createAction(EnrollmentFileActionType.GET_FILE_PROFILE_METRICS);
export const getAccountProfileMetrics = () =>
  createAction(EnrollmentFileActionType.GET_ACCOUNT_PROFILE_METRICS);
export const getFileTrackingMonitorMetrics = () =>
  createAction(EnrollmentFileActionType.GET_FILE_TRACKING_MONITOR_METRICS);

export const changeFileProfileMetrics = (
  fileProfileMetrics: Async<FileProfileMetricsPayload>
) =>
  createAction(
    EnrollmentFileActionType.CHANGE_FILE_PROFILE_METRICS,
    fileProfileMetrics
  );
export const changeAccountProfileMetrics = (
  accountProfileMetrics: Async<AccountProfileMetricsPayload>
) =>
  createAction(
    EnrollmentFileActionType.CHANGE_ACCOUNT_PROFILE_METRICS,
    accountProfileMetrics
  );
export const changeFileTrackingMonitorMetrics = (
  fileTrackingMonitorMetrics: Async<FileTrackingMonitorMetricsPayload>
) =>
  createAction(
    EnrollmentFileActionType.CHANGE_FILE_TRACKING_MONITOR_METRICS,
    fileTrackingMonitorMetrics
  );

export const getEnrollmentFile = (enrollmentFileId: string, isEMW: boolean) =>
  createAction(EnrollmentFileActionType.GET_ENROLLMENT_FILE, {
    enrollmentFileId,
    isEMW,
  });
export const getEnrollmentFileByCaseRequestId = (caseRequestId: string) =>
  createAction(EnrollmentFileActionType.GET_ENROLLMENT_FILE_By_CASE_REQUEST_ID, {caseRequestId});

export const changeEnrollmentFile = (enrollmentFile: Async<EnrollmentFileDetails>) =>
  createAction(EnrollmentFileActionType.CHANGE_ENROLLMENT_FILE, enrollmentFile);
export const changeEnrollmentFileFilters = (filters: EnrollmentFileFilters) =>
  createAction(EnrollmentFileActionType.CHANGE_ENROLLMENT_FILE_FILTERS, {
    filters,
  });
export const clearEnrollmentFiles = () => createAction(EnrollmentFileActionType.CLEAR_ENROLLMENT_FILES);
export const getEnrollmentFiles = (pageOption?: Page<EnrollmentFile>, filter?: EnrollmentFileFilters) => {
  const payload = pipe(
    O.fromNullable(pageOption),
    O.fold(constant(PageFetchAction.Initial({filter})), page =>
      PageFetchAction.Additional({existingPage: page, filter})
    )
  );
  return createAction(EnrollmentFileActionType.GET_ENROLLMENT_FILES, payload);
};
export const changeEnrollmentFileTab = (showEMW: boolean) =>
  createAction(EnrollmentFileActionType.CHANGE_ENROLLMENT_TAB, {showEMW});
export const changeEnrollmentFiles = (enrollmentFiles: AsyncPage<Page<EnrollmentFile>>) =>
  createAction(EnrollmentFileActionType.CHANGE_ENROLLMENT_FILES, enrollmentFiles);

export const getEnrollmentFileApplicationDetail = (
  pageOption?: Page<EnrollmentFileApplicationDetail>,
  filter?: EnrollmentApplicationDetailFilters
) => {
  const payload = pipe(
    O.fromNullable(pageOption),
    O.fold(constant(PageFetchAction.Initial({filter})), page =>
      PageFetchAction.Additional({existingPage: page, filter})
    )
  );
  return createAction(EnrollmentFileActionType.GET_ENROLLMENT_FILES_APPLICATION_DETAILS, payload);
};

export const changeEnrollmentApplicationDetailFilters = (
  enrollmentApplicationDetailFilters: EnrollmentApplicationDetailFilters
) =>
  createAction(
    EnrollmentFileActionType.CHANGE_ENROLLMENT_APPLICATION_DETAILS_FILTERS,
    enrollmentApplicationDetailFilters
  );

export const changeEnrollmentFileApplicationDetail = (
  enrollmentFilesApplicationDetails: AsyncPage<Page<EnrollmentFileApplicationDetail>>
) =>
  createAction(EnrollmentFileActionType.CHANGE_ENROLLMENT_FILES_APPLICATION_DETAILS, enrollmentFilesApplicationDetails);

export const getEnrollmentFileApplicationProcessingDetail = (id: string) =>
  createAction(EnrollmentFileActionType.GET_ENROLLMENT_FILES_APPLICATION_PROCESSING_DETAILS, {id});

export const changeEnrollmentFileApplicationProcessingDetail = (
  enrollmentFilesApplicationProcessingDetails: Async<ApplicationProcessingDetail[]>
) =>
  createAction(
    EnrollmentFileActionType.CHANGE_ENROLLMENT_FILES_APPLICATION_PROCESSING_DETAILS,
    enrollmentFilesApplicationProcessingDetails
  );

export const getEnrollmentFileAWDHistoryDetail = (id: string) =>
  createAction(EnrollmentFileActionType.GET_ENROLLMENT_FILES_AWD_HISTORY_DETAILS, {id});

export const changeEnrollmentFileAWDHistoryDetail = (enrollmentFilesAWDHistoryDetails: Async<AWDHistoryDetail>) =>
  createAction(EnrollmentFileActionType.CHANGE_ENROLLMENT_FILES_AWD_HISTORY_DETAILS, enrollmentFilesAWDHistoryDetails);

export const uploadEnrollmentApplications = (
  file: File,
  applicationTypeId: number,
  fileInUploadProgressId: string,
  cancelTokenSource: CancelTokenSource,
  id?: string,
  groupId?: string,
  fileId?: string
) =>
  createAction(EnrollmentFileActionType.UPLOAD_ENROLLMENT_FILE_APPLICATIONS, {
    file,
    applicationTypeId,
    fileInUploadProgressId,
    cancelTokenSource,
    id,
    groupId,
    fileId,
  });
export const uploadEmployerProfiles = (file: File) =>
  createAction(EnrollmentFileActionType.UPLOAD_ENROLLMENT_EMPLOYER_PROFILES, {
    file,
  });

export const getEnrollmentApplications = (
  pageOption?: Page<EnrollmentApplication>,
  filter?: EnrollmentApplicationsFilters,
  sort?: Sort
) => {
  const payload = pipe(
    O.fromNullable(pageOption),
    O.fold(constant(PageFetchAction.Initial({filter})), page =>
      PageFetchAction.Additional({existingPage: page, filter})
    )
  );
  return createAction(EnrollmentFileActionType.GET_ENROLLMENT_APPLICATIONS, payload, sort!);
};
export const changeEnrollmentApplications = (file: AsyncPage<Page<EnrollmentApplication>>) =>
  createAction(EnrollmentFileActionType.CHANGE_ENROLLMENT_APPLICATIONS, file);
export const changeEnrollmentApplicationFilters = (filters: EnrollmentApplicationsFilters) =>
  createAction(EnrollmentFileActionType.CHANGE_ENROLLMENT_APPLICATION_FILTERS, filters);

export const changeEnrollmentFileUploadFilters = (filters: EmployerProfileUploadFilters) =>
  createAction(EnrollmentFileActionType.CHANGE_ENROLLMENT_CLIENTONBOARDING_FILTERS, {
    filters,
  });

export const changeExternalUploadQueueFilters = (filters: ExternalUploadQueueFilters) =>
  createAction(EnrollmentFileActionType.CHANGE_EXTERNAL_UPLOAD_QUEUE_FILTERS, filters);
export const changeIsFileUploading = (isFileUploading: boolean) =>
  createAction(EnrollmentFileActionType.CHANGE_IS_FILE_UPLOADING, isFileUploading);

export const clearEnrollmentFileApplications = () =>
  createAction(EnrollmentFileActionType.CLEAR_ENROLLMENT_APPLICATIONS, DEFAULT_STATE.enrollmentApplications);

export const changeEmployerProfileUploadDetails = (file: AsyncPage<Page<EmployerProfileDetails>>) =>
  createAction(EnrollmentFileActionType.CHANGE_EMPLOYER_PROFILE_DETAILS, file);
export const getEmployerProfileUploadDetails = (
  pageOption?: Page<EmployerProfileDetails>,
  filter?: EmployerProfileUploadFilters,
  sort?: Sort
) => {
  const payload = pipe(
    O.fromNullable(pageOption),
    O.fold(constant(PageFetchAction.Initial({filter})), page =>
      PageFetchAction.Additional({existingPage: page, filter})
    )
  );
  return createAction(EnrollmentFileActionType.GET_EMPLOYER_PROFILE_DETAILS, payload, sort!);
};

export const changeEnrollmentApplicationErrorDetailFilters = (filters: EnrollmentApplicationErrorDetailFilters) =>
  createAction(EnrollmentFileActionType.CHANGE_ENROLLMENT_APPLICATION_ERROR_DETAIL_FILTERS, {filters});

export const getAllowedEnrollmentApplicationTemplates = () =>
  createAction(EnrollmentFileActionType.GET_ENROLLMENT_APPLICATION_TEMPLATE);

export const changeAllowedEnrollmentApplicationTemplates = (templates: Async<EnrollmentApplicationTemplate[]>) =>
  createAction(EnrollmentFileActionType.CHANGE_ENROLLMENT_APPLICATION_TEMPLATE, templates);

export const clearEnrollmentApplicationTemplates = () =>
  createAction(EnrollmentFileActionType.CLEAR_ENROLLMENT_APPLICATION_TEMPLATES);
export const saveAgreementAcknowledgment = () =>
  createAction(EnrollmentFileActionType.SAVE_FILE_UPLOAD_AGREEMENT_ACKNOWLEDGMENT);
export const changeAgreementAcknowledgment = (data: Async<AgreementAcknowledgment>) =>
  createAction(EnrollmentFileActionType.CHANGE_FILE_UPLOAD_AGREEMENT_ACKNOWLEDGMENT, data);
export const clearAgreementAcknowledgment = () =>
  createAction(EnrollmentFileActionType.CLEAR_FILE_UPLOAD_AGREEMENT_ACKNOWLEDGMENT);

export const updateEnrollmentFileAuditStatus = (fileId: string) =>
  createAction(EnrollmentFileActionType.UPDATE_ENROLLMENT_FILE_AUDIT_STATUS, {fileId});
export const changeAgreementAccepted = (agreementAccepted: boolean) =>
  createAction(EnrollmentFileActionType.CHANGE_AGREEMENT_ACCEPTED, agreementAccepted);
export const getEnrollmentFileAuditDetail = (fileId: string) =>
  createAction(EnrollmentFileActionType.GET_ENROLLMENT_FILE_AUDIT_DETAIL, {fileId});
export const changeEnrollmentFileAuditDetail = (data: Async<EnrollmentFileAuditDetail>) =>
  createAction(EnrollmentFileActionType.CHANGE_ENROLLMENT_FILE_AUDIT_DETAIL, data);
export const getEnrollmentFileRecordValidationResult = (fileId: string) =>
  createAction(EnrollmentFileActionType.GET_ENROLLMENT_FILE_RECORD_VALIDATION_RESULT, {fileId});

export const changeEnrollmentFileRecordValidationResult = (data: Async<EnrollmentFileRecordValidationResult>) =>
  createAction(EnrollmentFileActionType.CHANGE_ENROLLMENT_FILE_RECORD_VALIDATION_RESULT, data);

export const getLifeCycleReportChartDetails = (chartType: string) =>
  createAction(EnrollmentFileActionType.GET_LIFE_CYCLE_REPORT_CHART_DETAILS, {chartType});

export const changeLifeCycleReportChartDetails = (
  lifeCycleReportChartDetails: Async<LifeCycleReportChartDetailsPayload>
) => createAction(EnrollmentFileActionType.CHANGE_LIFE_CYCLE_REPORT_CHART_DETAILS, lifeCycleReportChartDetails);

export const getProcessingAccuracyChartDetails = (
  employerName?: string,
  agentNumbers?: string,
  isNewYork?: boolean,
  encryptedIdentifier?: string,
  caseNumbers?: string,
  productType?: string,
  startdate?: string,
  endDate?: string
) =>
  createAction(EnrollmentFileActionType.GET_PROCESSING_ACCURACY_CHART_DETAILS, {
    employerName,
    agentNumbers,
    isNewYork,
    encryptedIdentifier,
    caseNumbers,
    productType,
    startdate,
    endDate,
  });

export const changeProcessingAccuracyChartDetails = (
  processingAccuracyChartDetails: Async<ProcessingAccuracyChartDetailsPayload[]>
) => createAction(EnrollmentFileActionType.CHANGE_PROCESSING_ACCURACY_CHART_DETAILS, processingAccuracyChartDetails);

export const getDaysToCompleteTurnAroundChartDetails = () =>
  createAction(EnrollmentFileActionType.GET_DAYS_TO_COMPLETE_TURN_AROUND_CHART_DETAILS);

export const changeDaysToCompleteTurnAroundChartDetails = (
  daysToCompleteTurnAroundChartDetails: Async<DaysToCompleteTurnAroundChartDetailsPayload[]>
) =>
  createAction(
    EnrollmentFileActionType.CHANGE_DAYS_TO_COMPLETE_TURN_AROUND_CHART_DETAILS,
    daysToCompleteTurnAroundChartDetails
  );

export const getTotalRecordsChartDetails = () => createAction(EnrollmentFileActionType.GET_TOTAL_RECORDS_CHART_DETAILS);

export const changeTotalRecordsChartDetails = (totalRecordsChartDetails: Async<TotalRecordsChartDetailsPayload[]>) =>
  createAction(EnrollmentFileActionType.CHANGE_TOTAL_RECORDS_CHART_DETAILS, totalRecordsChartDetails);

  export const changeProcessAccuracyRecords = (isLoadData: boolean) =>
  createAction(EnrollmentFileActionType.CHANGE_FILTER_PROCESSACCURACY_CHART, {isLoadData});    

export const cancelExternalUploadQueue = (
  fileId: string,
  fileStatusId: number,
  filter?: ExternalUploadQueueFilters,
  removalReasonId?: number,
  returnComments?: string,
  uploadedByEmail?: string,
  actionBy?: string,
) =>
  createAction(EnrollmentFileActionType.CHANGE_EXTERNAL_ENROLLMENT_FILES, {
    fileId,
    fileStatusId,
    filter,
    removalReasonId,
    returnComments,
    uploadedByEmail,
    actionBy,
  });

export const cancelBrokerSpreadsheetUpload = (
  fileId: string,
  fileStatusId: number,
  filter?: ExternalUploadQueueFilters,
  removalReasonId?: number
) =>
  createAction(EnrollmentFileActionType.CHANGE_BROKER_SPREADSHEET_CANCEL, {
    fileId,
    fileStatusId,
    filter,
    removalReasonId,
  });

export const cancelGenelcoUploadQueue = (
  fileId: string,
  fileStatusId: number,
  filter?: EnrollmentApplicationsFilters,
  removalReasonId?: number
) =>
  createAction(EnrollmentFileActionType.CHANGE_GENELCO_ENROLLMENT_FILES, {
    fileId,
    fileStatusId,
    filter,
    removalReasonId,
  });

export const getEnrollmentApplicationsDetail = (id: string) =>
  createAction(EnrollmentFileActionType.GET_ENROLLMENT_APPLICATIONS_DETAIL, {id});

export const getEnrollmentErrorDetails = (id: string, filter?: EnrollmentApplicationErrorDetailFilters, sort?: Sort) =>
  createAction(EnrollmentFileActionType.GET_ENROLLMENT_ERROR_DETAILS, {id, filter, sort});

export const changeEnrollmentApplicationsDetail = (detail: Async<EnrollmentApplication[]>) =>
  createAction(EnrollmentFileActionType.CHANGE_ENROLLMENT_APPLICATIONS_DETAIL, detail);

export const changeEnrollmentErrorDetails = (detail: AsyncPage<Page<EnrollmentFileErrorDetails>>) =>
  createAction(EnrollmentFileActionType.CHANGE_ENROLLMENT_ERROR_DETAILS, detail);

export const getEnrollmentFileApplicationDetailById = (requestId: string, caseRequestId: string) =>
  createAction(EnrollmentFileActionType.GET_ENROLLMENT_File_APPLICATION_DETAIL, {requestId, caseRequestId});

export const changeEnrollmentFilesApplicationDetail = (data: Async<EnrollmentFileApplicationDetail>) =>
  createAction(EnrollmentFileActionType.CHANGE_ENROLLMENT_File_APPLICATION_DETAIL, data);

export const getExternalUploadQueue = (
  pageOption?: Page<ExternalUploadEnrollmentApplication>,
  filter?: EnrollmentApplicationsFilters
) => {
  const payload = pipe(
    O.fromNullable(pageOption),
    O.fold(constant(PageFetchAction.Initial({filter})), page =>
      PageFetchAction.Additional({existingPage: page, filter})
    )
  );
  return createAction(EnrollmentFileActionType.GET_EXTERNAL_UPLOAD_QUEUE, payload);
};

export const changeExternalUploadQueue = (data: AsyncPage<Page<ExternalUploadEnrollmentApplication>>) =>
  createAction(EnrollmentFileActionType.CHANGE_EXTERNAL_UPLOAD_QUEUE, data);

export const clearExternalUploadQueueFilters = () =>
  createAction(EnrollmentFileActionType.CLEAR_EXTERNAL_UPLOAD_QUEUE_FILTERS);

export const getFileVolumeChartDetail = (chartType: string, employerName?: string) =>
  createAction(EnrollmentFileActionType.GET_FILE_VOLUME_CHART_DETAILS, {chartType, employerName});

export const changeFileVolumeChartDetails = (data: Async<LifeCycleReportChartDetailsPayload>) =>
  createAction(EnrollmentFileActionType.CHANGE_FILE_VOLUME_CHART_DETAILS, data);

export const getEsrTotalRecodsChartDetails = (employerName?: string) =>
  createAction(EnrollmentFileActionType.GET_ESR_TOTAL_RECORDS, {employerName});

export const changeEsrTotalRecordsChartDetails = (data: Async<TotalRecordsChartDetailsPayload[]>) =>
  createAction(EnrollmentFileActionType.CHANGE_ESR_TOTAL_RECORDS, data);

export const getEmployers = () => createAction(EnrollmentFileActionType.GET_EMPLOYERS);

export const changeEmployers = (data: Async<Employer[]>) =>
  createAction(EnrollmentFileActionType.CHANGE_EMPLOYERS, data);

export const clearProcessingAccuracyChartDetails = () =>
  createAction(EnrollmentFileActionType.CLEAR_PROCESSING_ACCURACY_CHART_DETAILS);

export const clearFileVolumeChartDetails = () => createAction(EnrollmentFileActionType.CLEAR_FILE_VOLUME_CHART_DETAILS);

export const clearEsrTotalRecordsChartDetails = () => createAction(EnrollmentFileActionType.CLEAR_ESR_TOTAL_RECORDS);

export const getFilesInUploadProgress = () => createAction(EnrollmentFileActionType.GET_FILE_UPLOADS_IN_PROGRESS);

export const changeFileUploadsInProgress = (data: Async<FileUploadInProgress[]>) =>
  createAction(EnrollmentFileActionType.CHANGE_FILE_UPLOADS_IN_PROGRESS, data);

export const getBrokerSpreadsheetUploadsMetrics = () =>
  createAction(EnrollmentFileActionType.GET_BROKER_SPREADSHEET_UPLOADS_METRICS);

export const changeBrokerSpreadsheetUploadMetrics = (data: Async<BrokerSpreadsheetUploadsMetrics>) =>
  createAction(EnrollmentFileActionType.CHANGE_BROKER_SPREADSHEET_UPLOADS_METRICS, data);

export const getApplications = (filters: ApplicationsFilter, sort?: Sort) =>
  createAction(EnrollmentFileActionType.GET_APPLICATIONS, {filters, sort});

export const changeApplications = (data: Async<Application[]>) =>
  createAction(EnrollmentFileActionType.CHANGE_APPLICATIONS, data);

export const changeApplicationsFilters = (filter: ApplicationsFilter) =>
  createAction(EnrollmentFileActionType.CHANGE_APPLICATIONS_FILTERS, filter);

export const clearApplications = () => createAction(EnrollmentFileActionType.CLEAR_APPLICATIONS);

export const clearApplicationFilters = () => createAction(EnrollmentFileActionType.CLEAR_APPLICATIONS_FILTERS);

export const changeFileUploadCancelTokens = (fileUploadCancelTokens: FileUploadCancelTokenDetail[]) =>
  createAction(EnrollmentFileActionType.CHANGE_FILE_UPLOAD_CANCEL_TOKENS, fileUploadCancelTokens);

export const clearSort = () => createAction(EnrollmentFileActionType.CLEAR_CLIENT_ONBOARDING_SORT);

export const changeSort = (sort?: Sort) => createAction(EnrollmentFileActionType.CHANGE_CLIENT_ONBOARDING_SORT, {sort});

export const clearClientOnboarding = () =>
  createAction(EnrollmentFileActionType.CLEAR_CLIENT_ONBOARDING, DEFAULT_STATE.employerProfileUploadDetails);

export const clearGenelcoApplicationSort = () => createAction(EnrollmentFileActionType.CLEAR_GENELCO_APPLICATION_SORT);

export const changeGenelcoApplicationSort = (sort?: Sort) =>
  createAction(EnrollmentFileActionType.CHANGE_GENELCO_APPLICATION_SORT, {sort});

export const getAccountNumbers = () => createAction(EnrollmentFileActionType.GET_ACCOUNTNUMBERS);

export const changeAccountNumbers = (data: Async<AutoCompleteList[]>) =>
  createAction(EnrollmentFileActionType.CHANGE_ACCOUNTNUMBERS, data);

export const getProducts = () => createAction(EnrollmentFileActionType.GET_PRODUCTS);

export const changeProducts = (data: Async<any[]>) =>
  createAction(EnrollmentFileActionType.CHANGE_PRODUCTS, data);

  export const getExternalUploadDetailsQueue = (
    id: string,
    pageOption?: Page<ExternalUploadEnrollmentApplicationDetails>,
    filter?: ExternalUploadQueueDetailsFilters,
    sort?: Sort
  ) => {
    const payload = pipe(
      O.fromNullable(pageOption),
      O.fold(constant(PageFetchAction.Initial({filter})), page =>
        PageFetchAction.Additional({existingPage: page, filter})
      )
    );
    return createAction(EnrollmentFileActionType.GET_EXTERNAL_UPLOAD_DETAILS_QUEUE, payload, id, sort!);
  };
  
  export const changeExternalUploadDetailsQueue = (data: AsyncPage<Page<ExternalUploadEnrollmentApplicationDetails>>) =>
    createAction(EnrollmentFileActionType.CHANGE_EXTERNAL_UPLOAD_DETAILS_QUEUE, data);

    export const changeExternalUploadQueueDetailsFilters = (filters: ExternalUploadQueueDetailsFilters) =>
  createAction(EnrollmentFileActionType.CHANGE_EXTERNAL_UPLOAD_QUEUE_DETAILS_FILTERS, filters);

  export const clearExternalUploadQueueDetailsFilters = () =>
  createAction(EnrollmentFileActionType.CLEAR_EXTERNAL_UPLOAD_QUEUE_DETAILS_FILTERS);


type EnrollmentFileState = {
  policyNumber: string;
  enrollmentFiles: AsyncPage<Page<EnrollmentFile>>;
  enrollmentMetrics: Async<OverallEnrollmentMetricsPayload>;
  fileFeedbackMetrics: Async<FileFeedbackMetricsPayload>;
  filesNotProcessedMetrics: Async<FilesNotProcessedMetricsPayload>;
  fileProfileMetrics: Async<FileProfileMetricsPayload>;
  accountProfileMetrics: Async<AccountProfileMetricsPayload>;
  fileTrackingMonitorMetrics: Async<FileTrackingMonitorMetricsPayload>;
  enrollmentFile: Async<EnrollmentFileDetails>;
  enrollmentFilesFilter: EnrollmentFileFilters;
  enrollmentFileApplication: AsyncPage<Page<EnrollmentFileApplicationDetail>>;
  showEMW: boolean;
  applicationProcessingDetails: Async<ApplicationProcessingDetail[]>;
  AWDHistoryDetails: Async<AWDHistoryDetail>;
  enrollmentApplications: AsyncPage<Page<EnrollmentApplication>>;
  employerProfileUploadDetails: AsyncPage<Page<EmployerProfileDetails>>;
  isFileUploading: boolean;
  enrollmentApplicationsFilters: EnrollmentApplicationsFilters;
  employerProfileUploadFilters: EmployerProfileUploadFilters;
  enrollmentApplicationErrorDetailFilters: EnrollmentApplicationErrorDetailFilters;
  externalUploadQueueFilters: ExternalUploadQueueFilters;
  externalUploadQueueDetailsFilters: ExternalUploadQueueDetailsFilters;
  allowedEnrollmentApplicationTemplates: Async<EnrollmentApplicationTemplate[]>;
  agreementAcknowledgment: Async<AgreementAcknowledgment>;
  agreementAccepted: boolean;
  enrollmentFileAuditDetail: Async<EnrollmentFileAuditDetail>;
  enrollmentFileRecordValidationResult: Async<EnrollmentFileRecordValidationResult>;
  lifeCycleReportChartDetails: Async<LifeCycleReportChartDetailsPayload>;
  processingAccuracyChartDetails: Async<ProcessingAccuracyChartDetailsPayload[]>;
  daysToCompleteTurnAroundChartDetails: Async<DaysToCompleteTurnAroundChartDetailsPayload[]>;
  enrollmentApplicationDetailFilters: EnrollmentApplicationDetailFilters;
  totalRecordsChartDetails: Async<TotalRecordsChartDetailsPayload[]>;
  enrollmentApplicationsDetails: Async<EnrollmentApplication[]>;
  enrollmentFileApplicationDetail: Async<EnrollmentFileApplicationDetail>;
  externalUploadQueue: AsyncPage<Page<ExternalUploadEnrollmentApplication>>;
  fileVolumeChartDetails: Async<LifeCycleReportChartDetailsPayload>;
  esrTotoalRecordChartDetails: Async<TotalRecordsChartDetailsPayload[]>;
  employers: Async<Employer[]>;
  fileUploadsInProgress: Async<FileUploadInProgress[]>;
  brokerSpreadsheetUploadsMetrics: Async<BrokerSpreadsheetUploadsMetrics>;
  enrollmentFileErrorDetails: AsyncPage<Page<EnrollmentFileErrorDetails>>;
  applications: Async<Application[]>;
  applicationsFilters: ApplicationsFilter;
  fileUploadCancelTokens: FileUploadCancelTokenDetail[];
  sort: O.Option<Sort>;
  accountNumbers: Async<AutoCompleteList[]>;
  products: Async<any[]>;
  isLoadData: Boolean;
  externalUploadDetailsQueue: AsyncPage<Page<ExternalUploadEnrollmentApplicationDetails>>;
};

export const DEFAULT_STATE: EnrollmentFileState = {
  enrollmentFiles: new Empty(),
  enrollmentFile: new Empty(),
  enrollmentFilesFilter: ESREmptyEnrollmentFileFilter,
  policyNumber: '',
  enrollmentMetrics: new Empty(),
  fileFeedbackMetrics: new Empty(),
  filesNotProcessedMetrics: new Empty(),
  fileProfileMetrics: new Empty(),
  accountProfileMetrics: new Empty(),
  fileTrackingMonitorMetrics: new Empty(),
  enrollmentFileApplication: new Empty(),
  showEMW: false,
  applicationProcessingDetails: new Empty(),
  AWDHistoryDetails: new Empty(),
  enrollmentApplications: new Empty(),
  isFileUploading: false,
  enrollmentApplicationsFilters: enrollmentApplicationsFiltersEmpty,
  employerProfileUploadDetails: new Empty(),
  employerProfileUploadFilters: employerProfileUploadFiltersEmpty,
  enrollmentApplicationErrorDetailFilters: enrollmentApplicationErrorDetailFiltersEmpty,
  externalUploadQueueFilters: externalUploadQueueFiltersEmpty,
  externalUploadQueueDetailsFilters: externalUploadQueueDetailsFiltersEmpty,
  allowedEnrollmentApplicationTemplates: new Empty(),
  agreementAcknowledgment: new Empty(),
  agreementAccepted: false,
  enrollmentFileAuditDetail: new Empty(),
  enrollmentFileRecordValidationResult: new Empty(),
  lifeCycleReportChartDetails: new Empty(),
  processingAccuracyChartDetails: new Empty(),
  daysToCompleteTurnAroundChartDetails: new Empty(),
  enrollmentApplicationDetailFilters: {...enrollmentApplicationDetailFiltersEmpty},
  totalRecordsChartDetails: new Empty(),
  enrollmentApplicationsDetails: new Empty(),
  enrollmentFileApplicationDetail: new Empty(),
  externalUploadQueue: new Empty(),
  fileVolumeChartDetails: new Empty(),
  esrTotoalRecordChartDetails: new Empty(),
  employers: new Empty(),
  fileUploadsInProgress: new Empty(),
  brokerSpreadsheetUploadsMetrics: new Empty(),
  enrollmentFileErrorDetails: new Empty(),
  applications: new Empty(),
  applicationsFilters: applicationsFiltersEmpty,
  fileUploadCancelTokens: [],
  sort: O.none,
  accountNumbers: new Empty(),
  products: new Empty(),
  isLoadData: false,
  externalUploadDetailsQueue: new Empty(),
};

type EnrollmentFileAction =
    | ReturnType<typeof changeEnrollmentMetrics>
    | ReturnType<typeof changeFileFeedbackMetrics>
    | ReturnType<typeof changeFilesNotProcessedMetrics>
    | ReturnType<typeof changeEnrollmentFileFilters>
    | ReturnType<typeof changeFileProfileMetrics>
    | ReturnType<typeof changeAccountProfileMetrics>
    | ReturnType<typeof changeFileTrackingMonitorMetrics>
    | ReturnType<typeof getEnrollmentFiles>
    | ReturnType<typeof changeEnrollmentFile>
    | ReturnType<typeof changeEnrollmentFileTab>
    | ReturnType<typeof clearEnrollmentFiles>
    | ReturnType<typeof changeEnrollmentFiles>
    | ReturnType<typeof changeEnrollmentFileApplicationDetail>
    | ReturnType<typeof changeEnrollmentFileApplicationProcessingDetail>
    | ReturnType<typeof changeEnrollmentFileAWDHistoryDetail>
    | ReturnType<typeof changeEnrollmentApplications>
    | ReturnType<typeof changeEmployerProfileUploadDetails>
    | ReturnType<typeof changeIsFileUploading>
    | ReturnType<typeof changeEnrollmentApplicationFilters>
    | ReturnType<typeof changeEnrollmentApplicationErrorDetailFilters>
    | ReturnType<typeof changeExternalUploadQueueFilters>
    | ReturnType<typeof clearEnrollmentApplicationTemplates>
    | ReturnType<typeof changeAllowedEnrollmentApplicationTemplates>
    | ReturnType<typeof changeAgreementAcknowledgment>
    | ReturnType<typeof clearAgreementAcknowledgment>
    | ReturnType<typeof changeEnrollmentFileAuditDetail>
    | ReturnType<typeof changeAgreementAccepted>
    | ReturnType<typeof changeEnrollmentFileRecordValidationResult>
    | ReturnType<typeof changeLifeCycleReportChartDetails>
    | ReturnType<typeof changeProcessingAccuracyChartDetails>
    | ReturnType<typeof cancelExternalUploadQueue>
    | ReturnType<typeof changeDaysToCompleteTurnAroundChartDetails>
    | ReturnType<typeof changeEnrollmentApplicationDetailFilters>
    | ReturnType<typeof changeTotalRecordsChartDetails>
    | ReturnType<typeof changeEnrollmentApplicationsDetail>
    | ReturnType<typeof changeEnrollmentFilesApplicationDetail>
    | ReturnType<typeof changeExternalUploadQueue>
    | ReturnType<typeof clearExternalUploadQueueFilters>
    | ReturnType<typeof changeFileVolumeChartDetails>
    | ReturnType<typeof changeEsrTotalRecordsChartDetails>
    | ReturnType<typeof changeEmployers>
    | ReturnType<typeof clearProcessingAccuracyChartDetails>
    | ReturnType<typeof clearEsrTotalRecordsChartDetails>
    | ReturnType<typeof clearFileVolumeChartDetails>
    | ReturnType<typeof changeFileUploadsInProgress>
    | ReturnType<typeof changeBrokerSpreadsheetUploadMetrics>
    | ReturnType<typeof changeEnrollmentErrorDetails>
    | ReturnType<typeof changeApplications>
    | ReturnType<typeof changeApplicationsFilters>
    | ReturnType<typeof clearApplications>
    | ReturnType<typeof clearApplicationFilters>
    | ReturnType<typeof cancelGenelcoUploadQueue>
    | ReturnType<typeof changeFileUploadCancelTokens>
    | ReturnType<typeof changeEnrollmentFileUploadFilters>
    | ReturnType<typeof clearSort>
    | ReturnType<typeof changeSort>
    | ReturnType<typeof changeGenelcoApplicationSort>
    | ReturnType<typeof changeAccountNumbers>
    | ReturnType<typeof changeProducts>
    | ReturnType<typeof changeProcessAccuracyRecords>
    | ReturnType<typeof changeExternalUploadDetailsQueue>
    | ReturnType<typeof changeExternalUploadQueueDetailsFilters>
    | ReturnType<typeof clearExternalUploadQueueDetailsFilters>;

export default (state: EnrollmentFileState = DEFAULT_STATE, action: EnrollmentFileAction): EnrollmentFileState => {
  switch (action.type) {
    case EnrollmentFileActionType.CLEAR_ENROLLMENT_APPLICATION_TEMPLATES:
      return {
        ...state,
        allowedEnrollmentApplicationTemplates: DEFAULT_STATE.allowedEnrollmentApplicationTemplates,
      };
    case EnrollmentFileActionType.CLEAR_ENROLLMENT_FILES:
      return {
        ...state,
        enrollmentFiles: DEFAULT_STATE.enrollmentFiles,
      };
    case EnrollmentFileActionType.CHANGE_ENROLLMENT_TAB:
      return {
        ...state,
        enrollmentFiles: DEFAULT_STATE.enrollmentFiles,
        showEMW: action.payload.showEMW,
      };
    case EnrollmentFileActionType.CHANGE_ENROLLMENT_METRICS:
      return {
        ...state,
        enrollmentMetrics: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_FILEFEEDBACK_METRICS:
      return {
        ...state,
        fileFeedbackMetrics: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_FILESNOTPROCESSED_METRICS:
      return {
        ...state,
        filesNotProcessedMetrics: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_FILE_PROFILE_METRICS:
      return {
        ...state,
        fileProfileMetrics: action.payload,
      };

    case EnrollmentFileActionType.CHANGE_ACCOUNT_PROFILE_METRICS:
      return {
        ...state,
        accountProfileMetrics: action.payload,
      };

    case EnrollmentFileActionType.CHANGE_FILE_TRACKING_MONITOR_METRICS:
      return {
        ...state,
        fileTrackingMonitorMetrics: action.payload,
      };

    case EnrollmentFileActionType.CHANGE_ENROLLMENT_FILE:
      return {
        ...state,
        enrollmentFile: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_ENROLLMENT_FILE_FILTERS:
      return {
        ...state,
        enrollmentFilesFilter: action.payload.filters,
      };
    case EnrollmentFileActionType.CHANGE_ENROLLMENT_FILES:
      return {
        ...state,
        enrollmentFiles: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_ENROLLMENT_FILES_APPLICATION_DETAILS:
      return {
        ...state,
        enrollmentFileApplication: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_ENROLLMENT_FILES_APPLICATION_PROCESSING_DETAILS:
      return {
        ...state,
        applicationProcessingDetails: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_ENROLLMENT_APPLICATION_FILTERS:
      return {
        ...state,
        enrollmentApplicationsFilters: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_ENROLLMENT_APPLICATION_ERROR_DETAIL_FILTERS:
      return {
        ...state,
        enrollmentApplicationErrorDetailFilters: action.payload.filters,
      };
    case EnrollmentFileActionType.CHANGE_EXTERNAL_UPLOAD_QUEUE_FILTERS:
      return {
        ...state,
        externalUploadQueueFilters: action.payload,
      };
    case EnrollmentFileActionType.CLEAR_EXTERNAL_UPLOAD_QUEUE_FILTERS:
      return {
        ...state,
        externalUploadQueueFilters: DEFAULT_STATE.externalUploadQueueFilters,
      };
    case EnrollmentFileActionType.CHANGE_ENROLLMENT_APPLICATIONS:
      return {
        ...state,
        enrollmentApplications: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_EMPLOYER_PROFILE_DETAILS:
      return {
        ...state,
        employerProfileUploadDetails: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_IS_FILE_UPLOADING:
      return {
        ...state,
        isFileUploading: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_ENROLLMENT_APPLICATION_TEMPLATE:
      return {
        ...state,
        allowedEnrollmentApplicationTemplates: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_ENROLLMENT_FILES_AWD_HISTORY_DETAILS:
      return {
        ...state,
        AWDHistoryDetails: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_FILE_UPLOAD_AGREEMENT_ACKNOWLEDGMENT:
      return {
        ...state,
        agreementAcknowledgment: action.payload,
      };
    case EnrollmentFileActionType.CLEAR_FILE_UPLOAD_AGREEMENT_ACKNOWLEDGMENT:
      return {
        ...state,
        agreementAcknowledgment: DEFAULT_STATE.agreementAcknowledgment,
        agreementAccepted: DEFAULT_STATE.agreementAccepted,
      };
    case EnrollmentFileActionType.CHANGE_AGREEMENT_ACCEPTED:
      return {
        ...state,
        agreementAccepted: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_ENROLLMENT_FILE_AUDIT_DETAIL:
      return {
        ...state,
        enrollmentFileAuditDetail: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_ENROLLMENT_FILE_RECORD_VALIDATION_RESULT:
      return {
        ...state,
        enrollmentFileRecordValidationResult: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_LIFE_CYCLE_REPORT_CHART_DETAILS:
      return {
        ...state,
        lifeCycleReportChartDetails: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_PROCESSING_ACCURACY_CHART_DETAILS:
      return {
        ...state,
        processingAccuracyChartDetails: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_DAYS_TO_COMPLETE_TURN_AROUND_CHART_DETAILS:
      return {
        ...state,
        daysToCompleteTurnAroundChartDetails: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_TOTAL_RECORDS_CHART_DETAILS:
      return {
        ...state,
        totalRecordsChartDetails: action.payload,
      };

    case EnrollmentFileActionType.CHANGE_ENROLLMENT_APPLICATION_DETAILS_FILTERS:
      return {
        ...state,
        enrollmentApplicationDetailFilters: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_ENROLLMENT_APPLICATIONS_DETAIL:
      return {
        ...state,
        enrollmentApplicationsDetails: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_ENROLLMENT_File_APPLICATION_DETAIL:
      return {
        ...state,
        enrollmentFileApplicationDetail: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_EXTERNAL_UPLOAD_QUEUE:
      return {
        ...state,
        externalUploadQueue: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_FILE_VOLUME_CHART_DETAILS:
      return {
        ...state,
        fileVolumeChartDetails: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_ESR_TOTAL_RECORDS:
      return {
        ...state,
        esrTotoalRecordChartDetails: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_EMPLOYERS:
      return {
        ...state,
        employers: action.payload,
      };
    case EnrollmentFileActionType.CLEAR_PROCESSING_ACCURACY_CHART_DETAILS:
      return {
        ...state,
        processingAccuracyChartDetails: DEFAULT_STATE.processingAccuracyChartDetails,
      };
    case EnrollmentFileActionType.CLEAR_ESR_TOTAL_RECORDS:
      return {
        ...state,
        esrTotoalRecordChartDetails: DEFAULT_STATE.esrTotoalRecordChartDetails,
      };
    case EnrollmentFileActionType.CLEAR_FILE_VOLUME_CHART_DETAILS:
      return {
        ...state,
        fileVolumeChartDetails: DEFAULT_STATE.fileVolumeChartDetails,
      };
    case EnrollmentFileActionType.CHANGE_FILE_UPLOADS_IN_PROGRESS:
      return {
        ...state,
        fileUploadsInProgress: action.payload,
      };

    case EnrollmentFileActionType.CHANGE_BROKER_SPREADSHEET_UPLOADS_METRICS:
      return {
        ...state,
        brokerSpreadsheetUploadsMetrics: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_ENROLLMENT_ERROR_DETAILS:
      return {
        ...state,
        enrollmentFileErrorDetails: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_APPLICATIONS:
      return {
        ...state,
        applications: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_APPLICATIONS_FILTERS:
      return {
        ...state,
        applicationsFilters: action.payload,
      };
    case EnrollmentFileActionType.CLEAR_APPLICATIONS:
      return {
        ...state,
        applications: DEFAULT_STATE.applications,
      };
    case EnrollmentFileActionType.CLEAR_APPLICATIONS_FILTERS:
      return {
        ...state,
        applicationsFilters: DEFAULT_STATE.applicationsFilters,
      };
    case EnrollmentFileActionType.CHANGE_FILE_UPLOAD_CANCEL_TOKENS:
      return {
        ...state,
        fileUploadCancelTokens: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_ENROLLMENT_CLIENTONBOARDING_FILTERS:
      return {
        ...state,
        employerProfileUploadFilters: action.payload.filters,
      };
    case EnrollmentFileActionType.CLEAR_CLIENT_ONBOARDING_SORT:
      return {
        ...state,
        sort: DEFAULT_STATE.sort,
      };
    case EnrollmentFileActionType.CHANGE_CLIENT_ONBOARDING_SORT:
      return {
        ...state,
        sort: O.fromNullable(action.payload.sort),
      };
    case EnrollmentFileActionType.CHANGE_GENELCO_APPLICATION_SORT:
      return {
        ...state,
        sort: O.fromNullable(action.payload.sort),
      };
    case EnrollmentFileActionType.CHANGE_ACCOUNTNUMBERS:
      return {
        ...state,
        accountNumbers: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_PRODUCTS:
      return {
        ...state,
        products: action.payload,
      };
    case EnrollmentFileActionType.CHANGE_FILTER_PROCESSACCURACY_CHART:
      return {
        ...state,
        isLoadData: action.payload.isLoadData,
      };
      case EnrollmentFileActionType.CHANGE_EXTERNAL_UPLOAD_DETAILS_QUEUE:
        return {
          ...state,
          externalUploadDetailsQueue: action.payload,
        };
        case EnrollmentFileActionType.CHANGE_EXTERNAL_UPLOAD_QUEUE_DETAILS_FILTERS:
          return {
            ...state,
            externalUploadQueueDetailsFilters: action.payload,
          };
          case EnrollmentFileActionType.CLEAR_EXTERNAL_UPLOAD_QUEUE_DETAILS_FILTERS:
            return {
              ...state,
              externalUploadQueueDetailsFilters: DEFAULT_STATE.externalUploadQueueDetailsFilters,
            };
    default:
      return state;
  }
};
